import { ElementRef, ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthQuery, AuthService } from '@ascschool/core/auth';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter'; 
import { Announce } from '@ascschool/model/user/announce.model';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { SchoolService } from '@ascschool/services/organization/school.service'; 
import { AnnounceViewService } from '@ascschool/services/user/announce-view.service';
import { AnnounceService } from '@ascschool/services/user/announce.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-popup-view-thong-bao',
  templateUrl: './popup-view-thong-bao.component.html',
  styleUrls: ['./popup-view-thong-bao.component.scss']
})
export class PopupViewThongBaoComponent implements OnInit {
  @Input() value: any;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  
  private elementPageHeaderTable: ElementRef;
  isCollapse = true;
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  announce = new Announce();
  currentUser: any;
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  pageIndex: number = 1; 
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  dataList: any; 
  width: number;
  height: number; 
  heightPagnagation: number = 50;
  commonFilter = new CommonFilter();
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService, 
    private service: AnnounceViewService, 
    public sizePageService: SizePageService,
    public utilsService: UtilsService,  
    public _authService: AuthService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {   
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    if(this.value){ 
      this.commonFilter.AnnounceId = this.value
    } 
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.reload();
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataList = [];
    this.service.getAnnounceView(this.commonFilter).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = response && response.rowCount ? response.rowCount : 0;
        this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
        _this.dataList = list ? list : [];
        _this.loading = false;
      },
      (err: any) => {
        _this.dataList = [];
        _this.loading = false;
      }
    );
  }
  // GetById(id: number) {
  //   this.service.getAnnounceById(id).subscribe((res: any) => {
  //     this.announce = res;
  //   })
  // }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
 
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
}
